import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import ImagePreviewBox from "../shared/ImagePreviewBox";
import { isNil } from "lodash";
import { CloseRounded } from "@mui/icons-material";

/**
 * Association Chip Component
 */
const AssociationChip = ({
  children,
  icon,
  onClick,
  onDelete,
  attachmentId,
  endContent,
  background,
  color,
  tooltip,
  imagePreview,
}) => {
  const content = (
    <Box
      sx={{
        alignItems: "center",
        gap: 0.4,
        borderRadius: "8px",
        display: "flex",
        padding: "4px 5px",
        border: "1px solid #dde0e4",
        background: `${background} !important`,
        color: `${color} !important`,
        fontSize: "10px !important",
        position: "relative",
        paddingLeft: imagePreview ? "40px" : undefined,
        minHeight: imagePreview ? "32px" : undefined,
        ".MuiButton-icon": {
          mx: 0.2,
        },
        ".MuiSvgIcon-root": {
          fontSize: "14px !important",
        },
      }}
      color="gray"
    >
      {!imagePreview ? icon : null}

      <ImagePreviewBox imagePreview={imagePreview} />
      <Typography
        onClick={onClick}
        sx={{
          maxWidth: "200px",
          overflow: "hidden",
          cursor: isNil(onClick) ? "default" : "pointer",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: 400,
          lineHeight: 1.75,
          fontSize: "10px",
          mr: 1,
        }}
      >
        {children}
      </Typography>
      {endContent}
      {onDelete && (
        <Tooltip title="Remove">
          <IconButton
            onClick={() => onDelete(attachmentId)}
            sx={{ p: 0, color: "inherit" }}
            size="small"
          >
            <CloseRounded className="thin" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );

  return tooltip ? <Tooltip title={tooltip}>{content}</Tooltip> : content;
};
export default AssociationChip;
